import { InputTag } from '@arco-design/web-react'

function parseAmounts(raw: string): number[] {
  if (!raw?.trim()) return []
  try {
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed
      .map((v) => Number(v))
      .filter((n) => Number.isFinite(n) && n > 0)
  } catch {
    return []
  }
}

interface Props {
  value: string
  onChange: (json: string) => void
}

/** 可视化编辑 payment_setting.amount_options（正数数组） */
export default function AmountOptionsEditor({ value, onChange }: Props) {
  const amounts = parseAmounts(value)

  return (
    <InputTag
      value={amounts.map(String)}
      onChange={(tags) => {
        const nums = tags
          .map((t) => Number(String(t).trim()))
          .filter((n) => Number.isFinite(n) && n > 0)
        onChange(JSON.stringify(nums))
      }}
      placeholder="输入金额后回车，如 10、20、50"
      allowClear
      validate={(input) => {
        const n = Number(input.trim())
        return Number.isFinite(n) && n > 0
      }}
      style={{ width: '100%' }}
    />
  )
}

export function validateAmountOptions(raw: string): string | null {
  if (!raw?.trim()) return null
  try {
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return '必须是 JSON 数字数组'
    const seen = new Set<number>()
    for (const item of parsed) {
      const n = Number(item)
      if (!Number.isFinite(n) || n <= 0) return '每项须为正数'
      if (seen.has(n)) return `金额重复：${n}`
      seen.add(n)
    }
    return null
  } catch {
    return '不是合法的 JSON 数组'
  }
}
